// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SrrqX","col":"styles_col__1P2pq"};